module.exports = __webpack_public_path__ + "img/fi-korean-food.99224adc.jpg";